import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const pageTitles = {
  '/login': 'Login',
  '/forgot-password': 'Forgot Password',
  '/reset-password': 'Reset Password',
  '/dashboard': 'Dashboard',
  '/schedules': 'Schedules',
  '/schedules/physician': 'Physician Schedule',
  '/schedules/employee': 'Employee Schedule',
  '/timesheets': 'Timesheets',
  '/supplies': 'Supplies',
  '/training': 'Training',
  '/payroll': 'Payroll',
  '/onboarding': 'Onboarding',
  '/profile': 'Profile',
  '/admin/operations': 'Operations Dashboard',
  '/admin/finance': 'Finance',
  '/admin/users': 'User Management',
  '/admin/schedule-templates': 'Schedule Templates',
  '/admin/pay-periods': 'Pay Periods',
  '/admin/ytd-management': 'YTD Management',
  '/admin/cra-remittance': 'CRA Remittance',
  '/admin/onboarding-status': 'Onboarding Status',
  '/admin/training-compliance': 'Training Compliance',
  '/admin/assistant': 'Operations Assistant',
  '/admin/documents': 'Document Management',
  '/admin/audit-logs': 'Audit Logs',
  '/admin/supply-catalog': 'Supply Catalog',
  '/payroll/calculator': 'Payroll Calculator',
};

export function usePageTitle() {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;
    let title = pageTitles[path];
    
    // Check for partial matches for dynamic routes
    if (!title) {
      const matchingKey = Object.keys(pageTitles).find(key => 
        path.startsWith(key) && key !== '/'
      );
      title = matchingKey ? pageTitles[matchingKey] : null;
    }
    
    document.title = title 
      ? `Polar iHealth Portal — ${title}`
      : 'Polar iHealth Portal';
  }, [location.pathname]);
}

export default usePageTitle;
